export default [
    {
        path: '/second_language',
        name: 'secondLanguage',
        component: () => import('@/views/secondLanguage/add'),
        meta: { pageTitle: 'second language', breadcrumb: [{ text: 'language' }] },
    },

]
